import React from 'react';
import './Brand.css';

const Brand = () => (
  <span className="brand" aria-label="TenantVerify SA">
    <img className="brand__mark" src={`${process.env.PUBLIC_URL}/brand/tenantverify-mark.svg`} alt="" width="40" height="40" />
    <span className="brand__name">Tenant<span>Verify</span><small>SA</small></span>
  </span>
);

export default Brand;
